import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { detectPlatformFromUrl } from "../utils/ecommerce/detect-platform-from-url";

/**
 * Dán nhầm sàn ở trang "Mua sắm hoàn tiền" → tự mở trang đúng của sàn đó.
 *
 * User hay copy link TikTok rồi dán vào trang Shopee (hoặc ngược lại). Trước đây trang
 * chỉ hiện "không tìm thấy sản phẩm" — user tưởng món này không được hoàn tiền rồi bỏ
 * đi mua ngoài, tức là MẤT ĐƠN. Nay chuyển thẳng sang trang sàn đó kèm `?link=`, trang
 * kia tự dán + tự tra cứu (xem `useSharedLinkParam`).
 *
 * Link không nhận ra sàn nào → trả false, trang giữ nguyên luồng báo lỗi cũ (đừng đoán
 * mò rồi ném user sang trang sai).
 */

const PLATFORM_LABEL = {
    shopee: "Shopee",
    lazada: "Lazada",
    tiktok: "TikTok Shop",
    shopeefood: "ShopeeFood",
};

/**
 * @param {"shopee"|"lazada"|"tiktok"|"shopeefood"} current sàn của trang đang đứng
 * @returns {(text: string) => boolean} true = đã chuyển trang, nơi gọi PHẢI dừng tra cứu
 */
export function useWrongPlatformRedirect(current) {
    const navigate = useNavigate();

    return useCallback(
        (text) => {
            const result = detectPlatformFromUrl(text);
            if (!result || result.platform === current) return false;

            const label = PLATFORM_LABEL[result.platform];
            toast.info(`Link ${label} → chuyển sang trang hoàn tiền ${label}`);
            navigate(`${result.path}?link=${encodeURIComponent(result.url)}`);
            return true;
        },
        [current, navigate]
    );
}

export default useWrongPlatformRedirect;
